import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

interface UseLastUpdateParams {
  tableName: string;
  entityType?: string;
}

interface LastUpdateData {
  date: string;
  userName: string;
  updateType: string;
  recordsAffected: number;
}

export function useLastUpdate({ tableName, entityType }: UseLastUpdateParams) {
  return useQuery({
    queryKey: ['lastUpdate', tableName, entityType],
    queryFn: async (): Promise<LastUpdateData | null> => {
      let query = supabase
        .from('import_metadata')
        .select('last_updated_at, updated_by_name, update_type, records_affected')
        .eq('table_name', tableName)
        .order('last_updated_at', { ascending: false })
        .limit(1);

      if (entityType) {
        query = query.eq('entity_type', entityType);
      }

      const { data, error } = await query.maybeSingle();

      if (error) {
        console.error('Error fetching last update:', error);
        return null;
      }

      if (!data) {
        return null;
      }

      const formattedDate = format(
        new Date(data.last_updated_at),
        "dd/MM/yyyy 'às' HH:mm",
        { locale: ptBR }
      );

      return {
        date: formattedDate,
        userName: data.updated_by_name,
        updateType: data.update_type,
        recordsAffected: data.records_affected,
      };
    },
    refetchOnWindowFocus: false,
  });
}
